import { ButtonPrimeReact } from "@finanedi.es/storybook"
import { EN_CALENDAR, ES_CALENDAR } from "common/utils/date"
import { withFormik } from "formik"
import { addLocale } from "primereact/api"
import { Calendar } from "primereact/calendar"
import { useTranslation } from "react-i18next"
import * as Yup from "yup"

const FechaEmision = ({
  values,
  handleSubmit,
  onHide,
  handleChange,
  isValid,
}: {
  values: { fechaEmision: Date }
  handleSubmit: () => void
  onHide: () => void
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleChange: (value: $TSMigrationFixMe) => void
  isValid: boolean
}) => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  addLocale("es", ES_CALENDAR)
  addLocale("en", EN_CALENDAR)

  const DATE_TODAY = new Date()

  return (
    <form
      onSubmit={handleSubmit}
      autoComplete='off'
    >
      <div className='mb-2 p-fluid'>
        <div className='p-field'>
          <label htmlFor='calendar'>
            {t("crear.facturaRec.modal.emisionDateLabel")}
          </label>
          <Calendar
            id='calendar'
            name='fechaEmision'
            value={values.fechaEmision}
            locale={language}
            dateFormat='dd/mm/yy'
            maxDate={DATE_TODAY}
            mask='99/99/9999'
            onChange={handleChange}
            showIcon
            baseZIndex={2302}
          />
        </div>
      </div>
      <div className='mt-4 col'>
        <div className='row justify-content-end align-items-center'>
          <ButtonPrimeReact
            className='tw-mr-3 tw-h-10 tw-flex tw-justify-center tw-items-center !tw-text-text !tw-border-none !tw-bg-transparent tw-cursor-pointer hover:!tw-shadow'
            onClick={onHide}
          >
            {t("crear.facturaRec.modal.cancelButton")}
          </ButtonPrimeReact>
          <ButtonPrimeReact
            type='submit'
            disabled={!isValid}
            className='!tw-bg-primary hover:!tw-shadow hover:!tw-bg-primary-over'
          >
            {t("crear.facturaRec.modal.addButton")}
          </ButtonPrimeReact>
        </div>
      </div>
    </form>
  )
}

const validate = Yup.object().shape({
  fechaEmision: Yup.string().min(3).required(),
})

const FormFechaEmision = withFormik({
  validationSchema: validate,
  validateOnMount: true,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  mapPropsToValues: ({ fechaEmision }: $TSMigrationFixMe) => {
    return {
      fechaEmision: new Date(fechaEmision),
    }
  },
  handleSubmit: ({ fechaEmision }, { props }) => {
    props.onChange(fechaEmision)
    props.onHide()
  },
})(FechaEmision)

export default FormFechaEmision
